(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mombee-track-order"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MomBeeTrackOrderUtils = {
      normalize: function (value) {
        return String(value == null ? '' : value).replace(/[\s\u00a0\-\u2010-\u2015_.]+/g, '');
      },
      validate: function (value) {
        var cleaned = MomBeeTrackOrderUtils.normalize(value);
        if (cleaned === '') return { ok: false, reason: 'empty', value: cleaned };
        if (!/^[0-9]{10,20}$/.test(cleaned)) return { ok: false, reason: 'invalid', value: cleaned };
        return { ok: true, reason: null, value: cleaned };
      },
      buildUrl: function (baseUrl, param, number) {
        var base = String(baseUrl || 'https://postex.pk/tracking');
        var hashIndex = base.indexOf('#');
        if (hashIndex !== -1) base = base.slice(0, hashIndex);
        var separator = base.indexOf('?') === -1 ? '?' : '&';
        if (/[?&]$/.test(base)) separator = '';
        return base + separator + encodeURIComponent(param || 'tracking_number') + '=' + encodeURIComponent(number);
      }
    };

    window.MomBeeTrackOrderUtils = MomBeeTrackOrderUtils;

    if (typeof customElements === 'undefined' || customElements.get('mombee-track-order')) return;

    class MomBeeTrackOrder extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input');
        this.errorText = this.querySelector('.mombee-track__error-text');
        this.submitButton = this.querySelector('button[type="submit"]');
        if (!this.form || !this.input) return;
        this.form.noValidate = true;

        this.onSubmit = this.onSubmit.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onPageShow = this.onPageShow.bind(this);
        this.form.addEventListener('submit', this.onSubmit);
        this.input.addEventListener('input', this.onInput);
        window.addEventListener('pageshow', this.onPageShow);

        this.prefill();
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        if (this.input) this.input.removeEventListener('input', this.onInput);
        window.removeEventListener('pageshow', this.onPageShow);
      }

      prefill() {
        try {
          var params = new URLSearchParams(window.location.search);
          var value = params.get(this.dataset.param || 'tracking_number') || params.get('tracking_number') || params.get('tn');
          if (value) this.input.value = MomBeeTrackOrderUtils.normalize(value);
        } catch (error) {}
      }

      showError(reason) {
        var message = reason === 'empty' ? this.dataset.errorEmpty : this.dataset.errorInvalid;
        this.input.setAttribute('aria-invalid', 'true');
        this.classList.add('is-invalid');
        if (this.errorText) this.errorText.textContent = message || '';
      }

      clearError() {
        this.input.removeAttribute('aria-invalid');
        this.classList.remove('is-invalid');
        if (this.errorText) this.errorText.textContent = '';
      }

      onInput() {
        if (this.classList.contains('is-invalid')) this.clearError();
      }

      onPageShow() {
        if (this.submitButton) this.submitButton.removeAttribute('aria-disabled');
      }

      onSubmit(event) {
        event.preventDefault();
        var result = MomBeeTrackOrderUtils.validate(this.input.value);
        if (!result.ok) {
          this.showError(result.reason);
          this.input.focus();
          return;
        }
        this.clearError();
        this.input.value = result.value;
        var url = MomBeeTrackOrderUtils.buildUrl(this.dataset.baseUrl, this.dataset.param, result.value);
        if (this.dataset.newTab === 'true') {
          var opened = window.open(url, '_blank', 'noopener');
          if (!opened) window.location.assign(url);
          return;
        }
        if (this.submitButton) this.submitButton.setAttribute('aria-disabled', 'true');
        window.location.assign(url);
      }
    }

    customElements.define('mombee-track-order', MomBeeTrackOrder);
  })();

  } catch(e) { console.error(e); }
})();
})();
